<template>
  <div class="cdo-page">
    <nav class="breadcrumb-nav">
      <router-link to="/">首页</router-link>
      <span class="separator">/</span>
      <router-link to="/training">培训中心</router-link>
      <span class="separator">/</span>
      <span class="current">首席数据官CDO实践班</span>
    </nav>

    <!-- 英雄区（课程Banner） -->
    <section class="cdo-container" style="padding-top: 20px;">
      <div style="max-width: 1000px;">
        <div style="margin-bottom: 16px;">
          <span class="cdo-badge secondary">联合工信部课程</span>
          <span class="cdo-badge secondary">实战课程</span>
          <span class="cdo-badge secondary">一流师资</span>
          <span class="cdo-badge secondary">国标课程</span>
          <span class="cdo-badge secondary">权威认证</span>
        </div>
        <h1 class="cdo-h1">首席数据官CDO实践班<br><span style="color: var(--cdo-accent-blue);">Chief Data Officer Practice Program</span></h1>
        <p class="cdo-subhead">面向企业高层与数据负责人，构建数据战略规划、数据治理体系、数据资产管理与数据应用落地的全栈能力，实现从理论到实践的体系化提升。</p>
        <div style="display: flex; gap: 20px; flex-wrap: wrap; margin-top: 30px;">
          <a href="https://mp.weixin.qq.com/s/dh3_BPjh0wU5aheTEEyqbQ?scene=1&click_id=2" class="cdo-btn cdo-btn-primary" @click.prevent="goToAppointment">立即报名 <i class="fas fa-arrow-right" style="margin-left: 8px;"></i></a>
          <a href="https://mp.weixin.qq.com/s/dh3_BPjh0wU5aheTEEyqbQ?scene=1&click_id=2" class="cdo-btn cdo-btn-outline" @click.prevent="readNewpaper">官方文章 <i class="fas fa-newspaper" style="margin-left: 8px;"></i></a>
        </div>
      </div>

      <!-- 关键信息卡片 -->
      <div class="cdo-info-grid">
        <div class="cdo-info-card">
          <div class="cdo-info-icon"><i class="fas fa-clock"></i></div>
          <div>
            <h4>课程天数</h4>
            <p>3天集训（线下/线上）</p>
          </div>
        </div>
        <div class="cdo-info-card">
          <div class="cdo-info-icon"><i class="fas fa-certificate"></i></div>
          <div>
            <h4>认证证书</h4>
            <p>CDO证书（国标证书）</p>
          </div>
        </div>
        <div class="cdo-info-card">
          <div class="cdo-info-icon"><i class="fas fa-building"></i></div>
          <div>
            <h4>颁发机构</h4>
            <p>工信部电子标准技术研究院</p>
          </div>
        </div>
        <div class="cdo-info-card">
          <div class="cdo-info-icon"><i class="fas fa-users"></i></div>
          <div>
            <h4>已培训</h4>
            <p>3000+企业高管</p>
          </div>
        </div>
      </div>

      <!-- 关键词云（SEO强化） -->
      <div class="cdo-keyword-cloud">
        <div> 课程特色：</div>
        <h2 class="cdo-keyword-tag">首席数据官</h2>
        <h2 class="cdo-keyword-tag">CDO培训</h2>
        <h2 class="cdo-keyword-tag">数据战略规划</h2>
        <h2 class="cdo-keyword-tag">数据治理体系</h2>
        <h2 class="cdo-keyword-tag">数据资产管理</h2>
        <h2 class="cdo-keyword-tag">工信部认证</h2>
        <h2 class="cdo-keyword-tag">企业数字化转型</h2>
        <h2 class="cdo-keyword-tag">数据领导力</h2>
      </div>
    </section>

    <!-- 适合人群 -->
    <section class="cdo-container">
      <h2 class="cdo-h2"><i class="fas fa-user-tie"></i> 适合人群</h2>
      <div class="cdo-card-grid-3">
        <div class="cdo-feature-card">
          <div class="cdo-card-icon"><i class="fas fa-users-gear"></i></div>
          <h3 class="cdo-h3">企业高层管理者</h3>
          <p>•公司高层、CIO|CTO|CDO数字化转型负责人，需掌握数据战略规划与落地能力。<br>•企业董事长/总裁、总经理、企业高层领导团队、企业数字化转型委员会
<br>•高级管理人员(强烈推荐各业务分管领导、信息与数字化部、财务部、供应链部、运营管理、风控合规审计等主管领导和部门负责人)</p>
        </div>
        <div class="cdo-feature-card">
          <div class="cdo-card-icon"><i class="fas fa-database"></i></div>
          <h3 class="cdo-h3">数据部门负责人</h3>
          <p> •数据中心主任、数据管理部门负责人，负责企业数据治理与数据资产管理工作。<br> •企业数字化转型执行小组成员、数字化转型技术骨干、信息中心/数据中心负责人。<br> •数据分析团队负责人、数据科学家、数据工程师等技术骨干人员、负责推进企业数据中台、治理、分析及应用项目核心成员。</p>
        </div>
        <div class="cdo-feature-card">
          <div class="cdo-card-icon"><i class="fas fa-chart-line"></i></div>
          <h3 class="cdo-h3">业务部门数字化项目负责人</h3>
          <p> •企业数字化转型项目负责人、业务部门数字化项目负责人、数据分析团队负责人。  <br> •业务部门从事数字化转型、IT规划、数据分析、数据治理、数据应用实践及数据人才培养建设相关人员。 <br>  •从事数据开发治理:数据管理、数据合规、数据资产评估、数据交易等企业人员。数据使用及分析场景较多的关键岗位人员。 </p>
        </div>
      </div>
    </section>

    <!-- 课程收益 -->
    <section class="cdo-container bg-light">
      <h2 class="cdo-h2"><i class="fas fa-trophy"></i> 课程收益</h2>

      <div class="cdo-benefit-grid">   <!-- 新增的网格容器 -->
        <div class="cdo-benefit-item">
          <div class="cdo-benefit-number">01</div>
          <div>
            <h3 class="cdo-h3">课程体系完善，实践导向：</h3>
            <p> • 能够让零基础的学员系统学习数据相关知识技能，全面涵盖数政策、数据管理体系、数据产品及价值、数据合规与出境、数据资产入表、AI实践、智能体规划建设，覆盖企业数据管理的方方面面。课程内容包括：数据、AI、智能体、数据出境及合规、数据资产入表、数据交易等内容，旨在让学员学以致用，提高实际应用能力。</p>
          </div>
        </div>
        <div class="cdo-benefit-item">
          <div class="cdo-benefit-number">02</div>
          <div>
            <h3 class="cdo-h3">师资阵容强大，精英授课</h3>
            <p> • 五位授课老师精通数据治理、数据分析、数据挖掘、AI、智能体技术领域，对企业数据战略、数据建设落地、数据合规、数据管理体系建设有着独到的见解和实践经验。将以深入浅出的方式，结合实际案例，将复杂的数据知识和技术转化为易于理解和掌握的内容，让学员能够快速提升自己的数据素养和实践能力。</p>
          </div>
        </div>
        <div class="cdo-benefit-item">
          <div class="cdo-benefit-number">03</div>
          <div>
            <h3 class="cdo-h3">国标证书，权威机构颁布：</h3>
            <p> • 颁发证书，权威认证：完成全部课程学习并通过考试后，学员可获得由工业和信息化部电子工业标准化研究院颁发的首席数据官CDO认证证书。官网可查，权威认证。证书具有多种用途，如在企业招投标中作为加分条件，有助于企业核心竞争力。同时证书也可提升个人素质评价，有利于树立个人形象，提高待遇水平。</p>
          </div>
        </div>

      </div>
    </section>

    <!-- 课程大纲 -->
    <section class="cdo-container">
      <h2 class="cdo-h2"><i class="fas fa-book-open"></i> 课程大纲（3天集训）</h2>
      <div class="cdo-curriculum">
        <div class="cdo-day-card">
          <div class="cdo-day-header">
            <span class="cdo-day-badge">Day 1</span>
            <h3 class="cdo-h3">数据战略与组织设计</h3>
          </div>
          <ul class="cdo-curriculum-list">
            <li><i class="fas fa-check-circle"></i> 数字化转型与数据战略规划</li>
            <li><i class="fas fa-check-circle"></i> 数据驱动的组织架构设计</li>
            <li><i class="fas fa-check-circle"></i> CDO角色定位与职责</li>
            <li><i class="fas fa-check-circle"></i> 数据成熟度评估模型</li>
            <li><i class="fas fa-check-circle"></i> <strong>案例：</strong>某央企数据战略规划实践</li>
          </ul>
        </div>

        <div class="cdo-day-card">
          <div class="cdo-day-header">
            <span class="cdo-day-badge">Day 2</span>
            <h3 class="cdo-h3">数据治理与资产管理</h3>
          </div>
          <ul class="cdo-curriculum-list">
            <li><i class="fas fa-check-circle"></i> 数据治理框架（DAMA DMBOK）</li>
            <li><i class="fas fa-check-circle"></i> 数据标准与数据质量管理</li>
            <li><i class="fas fa-check-circle"></i> 主数据管理与元数据管理</li>
            <li><i class="fas fa-check-circle"></i> 数据资产识别、评估与运营</li>
            <li><i class="fas fa-check-circle"></i> 数据安全与合规</li>
            <li><i class="fas fa-check-circle"></i> <strong>实战：</strong>数据治理体系设计工作坊</li>
          </ul>
        </div>

        <div class="cdo-day-card">
          <div class="cdo-day-header">
            <span class="cdo-day-badge">Day 3</span>
            <h3 class="cdo-h3">数据应用与价值实现</h3>
          </div>
          <ul class="cdo-curriculum-list">
            <li><i class="fas fa-check-circle"></i> 数据分析与商业智能</li>
            <li><i class="fas fa-check-circle"></i> AI与大数据应用场景</li>
            <li><i class="fas fa-check-circle"></i> 数据价值变现路径</li>
            <li><i class="fas fa-check-circle"></i> 数据中台架构与实施</li>
            <li><i class="fas fa-check-circle"></i> 数据文化建设与变革管理</li>
            <li><i class="fas fa-check-circle"></i> <strong>案例分享：</strong>银行/能源/制造行业最佳实践</li>
            <li><i class="fas fa-check-circle"></i> <strong>考核：</strong>CDO认证考试</li>
          </ul>
        </div>
      </div>
    </section>

    <!-- 师资力量 -->
    <section class="cdo-container bg-light">
      <h2 class="cdo-h2"><i class="fas fa-chalkboard-user"></i> 师资力量</h2>
      <div class="cdo-card-grid-3">
        <div class="cdo-teacher-card">
          <div class="cdo-avatar"><i class="fas fa-user-graduate"></i></div>
          <h4 class="cdo-h4">张立华</h4>
          <p class="cdo-teacher-title">CDMP大师 / 原阿里数据总监</p>
          <ul class="cdo-teacher-info">
            <li>• 20年数据管理经验</li>
            <li>• 服务200+企业数据治理项目</li>
            <li>• 工信部数据治理专家组成员</li>
          </ul>
        </div>
        <div class="cdo-teacher-card">
          <div class="cdo-avatar"><i class="fas fa-user-tie"></i></div>
          <h4 class="cdo-h4">王敏</h4>
          <p class="cdo-teacher-title">工信部数字化转型顾问</p>
          <ul class="cdo-teacher-info">
            <li>• 15年央企数字化咨询经验</li>
            <li>• 主导50+央企数据战略规划</li>
            <li>• 《企业数据战略》作者</li>
          </ul>
        </div>
        <div class="cdo-teacher-card">
          <div class="cdo-avatar"><i class="fas fa-user-shield"></i></div>
          <h4 class="cdo-h4">李建国</h4>
          <p class="cdo-teacher-title">数据资产管理专家</p>
          <ul class="cdo-teacher-info">
            <li>• 原某银行数据管理部总经理</li>
            <li>• 国家数据资产标准起草人</li>
            <li>• 服务100+金融机构数据治理</li>
          </ul>
        </div>
      </div>
    </section>

    <!-- 成功案例 -->
    <section class="cdo-container">
      <h2 class="cdo-h2"><i class="fas fa-award"></i> 成功案例</h2>
      <div class="cdo-case-grid">
        <div class="cdo-case-card">
          <div class="cdo-case-header">
            <span class="cdo-industry-tag">金融</span>
            <h4 class="cdo-h4">某国有大型银行</h4>
          </div>
          <p><strong>培训规模：</strong>500+人次（分5期完成）</p>
          <p><strong>培训对象：</strong>总行数据管理部、各分行数据负责人</p>
          <p><strong>培训成果：</strong>35人通过CDO认证，建立企业级数据治理体系，数据质量提升40%</p>
        </div>
        <div class="cdo-case-card">
          <div class="cdo-case-header">
            <span class="cdo-industry-tag">能源</span>
            <h4 class="cdo-h4">某国家能源集团</h4>
          </div>
          <p><strong>培训规模：</strong>300+人次</p>
          <p><strong>培训对象：</strong>集团及各子公司CIO、数据部门负责人</p>
          <p><strong>培训成果：</strong>建立集团统一数据标准，实现跨业务板块数据共享</p>
        </div>
        <div class="cdo-case-card">
          <div class="cdo-case-header">
            <span class="cdo-industry-tag">制造</span>
            <h4 class="cdo-h4">某汽车制造集团</h4>
          </div>
          <p><strong>培训规模：</strong>200+人次</p>
          <p><strong>培训对象：</strong>数字化转型办公室、IT部门、业务部门</p>
          <p><strong>培训成果：</strong>构建工业互联网数据平台，设备数据利用率提升60%</p>
        </div>
      </div>

      <!-- 客户Logo墙 -->
      <div class="cdo-logo-wall">
        <h4 style="text-align: center; margin-bottom: 20px; color: #64748b;">服务过的部分客户</h4>
        <div class="cdo-logo-grid">
          <span class="cdo-logo-item">中国银行</span>
          <span class="cdo-logo-item">国家能源</span>
          <span class="cdo-logo-item">一汽集团</span>
          <span class="cdo-logo-item">南方电网</span>
          <span class="cdo-logo-item">华润集团</span>
          <span class="cdo-logo-item">上汽通用</span>
          <span class="cdo-logo-item">中石化</span>
          <span class="cdo-logo-item">中国移动</span>
        </div>
      </div>
    </section>

    <!-- 历史活动信息 -->
    <section class="cdo-container bg-light">
      <h2 class="cdo-h2"><i class="fas fa-landmark"></i> 历史CDO课程活动</h2>
      <div class="cdo-history-grid">
        <article class="cdo-history-card">
          <div class="cdo-history-label">活动 01</div>
          <h3 class="cdo-h3">古杉数据联合多机构成功举办 2026 首席数据官 CDO（实践班）首次公开课</h3>
          <p>公开报道回顾了首期公开课的组织情况与课程实践亮点。</p>
          <a
            href="https://baijiahao.baidu.com/s?id=1855460944540939594&wfr=spider&for=pc"
            target="_blank"
            rel="noopener noreferrer"
            class="cdo-history-link"
          >查看原文 <i class="fas fa-up-right-from-square" style="margin-left: 6px;"></i></a>
        </article>

        <article class="cdo-history-card">
          <div class="cdo-history-label">活动 02</div>
          <h3 class="cdo-h3">工信部电标院-官方联合举办培训业务文件</h3>
          <p>官方发布的联合举办培训业务相关文件与通知信息。</p>
          <a
            href="https://www.cesi.cn/202603/11601.html"
            target="_blank"
            rel="noopener noreferrer"
            class="cdo-history-link"
          >查看原文 <i class="fas fa-up-right-from-square" style="margin-left: 6px;"></i></a>
        </article>

        <article class="cdo-history-card">
          <div class="cdo-history-label">活动 03</div>
          <h3 class="cdo-h3">首席数据官CDO(实践班)培训 | 古杉联合电标院 | 国标项目</h3>
          <p>微信公众号文章介绍了项目背景、课程特色和合作机构信息。</p>
          <a
            href="https://mp.weixin.qq.com/s/1M3UJs7OF3nHLbKgONgWrQ"
            target="_blank"
            rel="noopener noreferrer"
            class="cdo-history-link"
          >查看原文 <i class="fas fa-up-right-from-square" style="margin-left: 6px;"></i></a>
        </article>

        <article class="cdo-history-card">
          <div class="cdo-history-label">活动 04</div>
          <h3 class="cdo-h3">[2026] 工信部首席数据官（实践班）课程长期招生|实战课程|国标项目</h3>
          <p>长期招生信息，包含课程安排、实战定位与国标项目说明。</p>
          <a
            href="https://mp.weixin.qq.com/s?__biz=MzIyMjE3OTM4NA==&mid=2247486990&idx=1&sn=eb84da28d77a7e3857a2c1056f16006f&scene=21&poc_token=HGMuqmmjJkkcNByDVm4Emhgei3s6m1GXDgyvncMm"
            target="_blank"
            rel="noopener noreferrer"
            class="cdo-history-link"
          >查看原文 <i class="fas fa-up-right-from-square" style="margin-left: 6px;"></i></a>
        </article>

        <article class="cdo-history-card">
          <div class="cdo-history-label">活动 05</div>
          <h3 class="cdo-h3">首席数据官CDO（实践班）高级研修课程（模块包括：数据管理体系建设培训｜数据资产管理落地实战|数据资产入表|AI实战)-全网唯一国标项目-古杉数据联合电标院</h3>
          <p>专题文章介绍课程模块设计与项目定位，展示国标项目的实战培训体系。</p>
          <a
            href="https://zhuanlan.zhihu.com/p/2004852448678933007"
            target="_blank"
            rel="noopener noreferrer"
            class="cdo-history-link"
          >查看原文 <i class="fas fa-up-right-from-square" style="margin-left: 6px;"></i></a>
        </article>
      </div>
    </section>

    <!-- 认证证书 -->
    <section class="cdo-container bg-light">
      <h2 class="cdo-h2"><i class="fas fa-certificate"></i> 认证证书</h2>
      <div style="max-width: 800px; margin: 0 auto;">
        <div class="cdo-cert-card">
          <div class="cdo-cert-icon"><i class="fas fa-scroll"></i></div>
          <div>
            <h3 class="cdo-h3">首席数据官（CDO）认证证书</h3>
            <p style="margin-bottom: 12px;">完成3天课程学习并通过考核后，由<strong>工信部电子标准技术研究院</strong>颁发国标认证证书。</p>
            <ul class="cdo-cert-info">
              <li><i class="fas fa-check"></i> 国家认可的权威证书</li>
              <li><i class="fas fa-check"></i> 企业数字化转型人才库备案</li>
              <li><i class="fas fa-check"></i> 行业广泛认可的能力证明</li>
              <li><i class="fas fa-check"></i> 终身有效（可查询验证）</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- 培训模式 -->
    <section class="cdo-container">
      <h2 class="cdo-h2"><i class="fas fa-graduation-cap"></i> 培训模式</h2>
      <div class="cdo-card-grid-2">
        <div class="cdo-mode-card">
          <h3 class="cdo-h3"><i class="fas fa-users"></i> 公开课</h3>
          <ul class="cdo-mode-list">
            <li><strong>开班频率：</strong>每月1-2期</li>
            <li><strong>开班城市：</strong>北京、上海、深圳、成都</li>
            <li><strong>课程时长：</strong>3天集训（周五-周日）</li>
            <li><strong>培训方式：</strong>线下面授 + 在线直播</li>
            <li><strong>费用：</strong>9800元/人（含培训费、教材费、证书费）</li>
          </ul>
          <a href="#" class="cdo-btn cdo-btn-primary" @click.prevent="openModal" style="width: 100%; text-align: center; margin-top: 20px;">报名公开课</a>
        </div>
        <div class="cdo-mode-card">
          <h3 class="cdo-h3"><i class="fas fa-building"></i> 企业内训</h3>
          <ul class="cdo-mode-list">
            <li><strong>培训对象：</strong>企业定制（20人起）</li>
            <li><strong>培训地点：</strong>企业指定地点或培训基地</li>
            <li><strong>课程内容：</strong>根据企业需求定制</li>
            <li><strong>培训方式：</strong>线下面授 + 实战辅导</li>
            <li><strong>费用：</strong>按项目报价（含专家费、教材费、证书费）</li>
          </ul>
          <a href="#" class="cdo-btn cdo-btn-outline" @click.prevent="openModal" style="width: 100%; text-align: center; margin-top: 20px;">咨询企业内训</a>
        </div>
      </div>
    </section>

    <!-- 报名流程 -->
    <section class="cdo-container bg-light">
      <h2 class="cdo-h2"><i class="fas fa-clipboard-list"></i> 报名流程</h2>
      <div class="cdo-process">
        <div class="cdo-process-step">
          <div class="cdo-process-number">1</div>
          <h4 class="cdo-h4">咨询了解</h4>
          <p>联系课程顾问，了解课程详情与开班计划</p>
        </div>
        <div class="cdo-process-arrow"><i class="fas fa-arrow-right"></i></div>
        <div class="cdo-process-step">
          <div class="cdo-process-number">2</div>
          <h4 class="cdo-h4">填写报名表</h4>
          <p>提交报名信息，确认课程时间与地点</p>
        </div>
        <div class="cdo-process-arrow"><i class="fas fa-arrow-right"></i></div>
        <div class="cdo-process-step">
          <div class="cdo-process-number">3</div>
          <h4 class="cdo-h4">缴纳费用</h4>
          <p>完成费用支付，获得正式学员资格</p>
        </div>
        <div class="cdo-process-arrow"><i class="fas fa-arrow-right"></i></div>
        <div class="cdo-process-step">
          <div class="cdo-process-number">4</div>
          <h4 class="cdo-h4">参加培训</h4>
          <p>按时参加培训，完成学习与考核</p>
        </div>
        <div class="cdo-process-arrow"><i class="fas fa-arrow-right"></i></div>
        <div class="cdo-process-step">
          <div class="cdo-process-number">5</div>
          <h4 class="cdo-h4">获得证书</h4>
          <p>通过考核后，获得CDO认证证书</p>
        </div>
      </div>
    </section>

    <!-- 常见问题 -->
    <section class="cdo-container">
      <h2 class="cdo-h2"><i class="fas fa-circle-question"></i> 常见问题</h2>
      <div class="cdo-faq">
        <div class="cdo-faq-item">
          <h4 class="cdo-h4">Q: 需要具备什么基础才能参加CDO实践班？</h4>
          <p>A: 建议具备3年以上工作经验，有一定的数据管理或IT管理背景。课程面向管理层，不需要编程基础。</p>
        </div>
        <div class="cdo-faq-item">
          <h4 class="cdo-h4">Q: 证书的含金量如何？</h4>
          <p>A: CDO证书由工信部电子标准技术研究院颁发，是国家认可的权威证书，在企业数字化转型领域具有很高的认可度。</p>
        </div>
        <div class="cdo-faq-item">
          <h4 class="cdo-h4">Q: 培训后能获得哪些支持？</h4>
          <p>A: 培训结束后，学员可加入CDO校友会，获得持续的学习资源、行业交流机会以及专家咨询支持。</p>
        </div>
        <div class="cdo-faq-item">
          <h4 class="cdo-h4">Q: 企业内训如何定制？</h4>
          <p>A: 我们会安排专家进行需求调研，根据企业的行业特点、数据管理现状和培训目标，定制专属的培训内容和实战案例。</p>
        </div>
      </div>
    </section>

    <!-- CTA区（强转化） -->
    <section class="cdo-cta">
      <div class="cdo-container">
        <div class="cdo-cta-content">
          <h2 class="cdo-h2" style="color: black; margin-bottom: 16px;">开启您的CDO职业之旅</h2>
          <p style="color: black; font-size: 18px; margin-bottom: 30px;">15分钟内为您匹配课程专家，提供1对1咨询服务</p>
          <div style="display: flex; gap: 20px; justify-content: center; flex-wrap: wrap;">
            <a href="#" class="cdo-btn cdo-btn-white" @click.prevent="goToAppointment">立即报名 <i class="fas fa-arrow-right" style="margin-left: 8px;"></i></a>
            <a href="#" class="cdo-btn cdo-btn-outline-white" @click.prevent="openModal">咨询课程顾问</a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'TrainingDetailCDO',
  methods: {
    goToAppointment() {
      this.$router.push('/appointment')
    },
    openModal() {
      alert('报名功能开发中，请联系客服：400-XXX-XXXX')
    },
    readNewpaper() {
      window.open('https://www.cesi.cn/202603/11601.html', '_blank', 'noopener,noreferrer')
    },
    downloadBrochure() {
      alert('课程大纲下载功能开发中')
    }
  }
}
</script>

<style scoped>
:root {
  --cdo-primary-dark: #0b2960;
  --cdo-accent-blue: #1a73e8;
  --cdo-text-dark: #1e293b;
  --cdo-text-gray: #64748b;
  --cdo-bg-light: #f8fafc;
  --cdo-border-light: #e2e8f0;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.cdo-page {
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  background-color: #ffffff;
  color: var(--cdo-text-dark);
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
}

/* 面包屑导航 */
.breadcrumb-nav {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 20px 10px;
  font-size: 14px;
  color: var(--cdo-text-gray);
}

.breadcrumb-nav a {
  color: var(--cdo-accent-blue);
  text-decoration: none;
  transition: color 0.2s;
}

.breadcrumb-nav a:hover {
  color: #0e5bbf;
}

.breadcrumb-nav .separator {
  margin: 0 8px;
  color: #cbd5e1;
}

.breadcrumb-nav .current {
  color: var(--cdo-text-dark);
  font-weight: 500;
}

/* 容器 */
.cdo-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 15px 10px;
}

/* 背景辅助类 */
.bg-light {
  background-color: var(--cdo-bg-light);
}

/* 标题样式 */
.cdo-h1 {
  font-size: 42px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 24px;
  color: var(--cdo-primary-dark);
}

.cdo-h2 {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 20px;
  color: var(--cdo-primary-dark);
  text-align: center;
}

.cdo-h2 i {
  margin-right: 12px;
  color: var(--cdo-accent-blue);
}

.cdo-h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
  color: var(--cdo-text-dark);
}

.cdo-h4 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--cdo-text-dark);
}

.cdo-subhead {
  font-size: 18px;
  color: var(--cdo-text-gray);
  line-height: 1.7;
  margin-bottom: 20px;
}

/* 徽章 */
.cdo-badge {
  display: inline-block;
  background: var(--cdo-accent-blue);
  color: white;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  margin-right: 10px;
}

.cdo-badge.secondary {
  background: #10b981;
}

/* 按钮 */
.cdo-btn {
  display: inline-block;
  padding: 14px 32px;
  border-radius: 40px;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.cdo-btn-primary {
  background: var(--cdo-accent-blue);
  color: #1D4E4E;
  border-color: var(--cdo-accent-blue);
  box-shadow: 0 4px 12px rgba(26, 115, 232, 0.2);
}

.cdo-btn-primary:hover {
  background: #0e5bbf;
  border-color: #0e5bbf;
  box-shadow: 0 6px 20px rgba(26, 115, 232, 0.3);
  transform: translateY(-2px);
}

.cdo-btn-outline {
  background: transparent;
  color: var(--cdo-accent-blue);
  border-color: var(--cdo-accent-blue);
}

.cdo-btn-outline:hover {
  background: var(--cdo-accent-blue);
  color: white;
}

.cdo-btn-white {
  background: #1F3F8F;
  color: white;
  border-color: #1F3F8F;
}

.cdo-btn-white:hover {
  background: #1F3F8F;
  transform: translateY(-2px);
}

.cdo-btn-outline-white {
  background: transparent;
  color: #1F3F8F;
  border-color: #1F3F8F;
}

.cdo-btn-outline-white:hover {
  background: rgba(255, 255, 255, 0.1);
}

/* 信息卡片网格 */
.cdo-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin: 40px 0;
}

.cdo-info-card {
  display: flex;
  align-items: center;
  gap: 16px;
  background: white;
  border: 1px solid var(--cdo-border-light);
  border-radius: 12px;
  padding: 20px;
  transition: all 0.3s ease;
}

.cdo-info-card:hover {
  border-color: var(--cdo-accent-blue);
  box-shadow: 0 4px 12px rgba(26, 115, 232, 0.1);
  transform: translateY(-2px);
}

.cdo-info-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  flex-shrink: 0;
}

.cdo-info-card h4 {
  font-size: 14px;
  color: var(--cdo-text-gray);
  margin-bottom: 4px;
  font-weight: 500;
}

.cdo-info-card p {
  font-size: 16px;
  color: var(--cdo-text-dark);
  font-weight: 600;
  margin: 0;
}

/* 关键词云 */
.cdo-keyword-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 30px;
}

.cdo-keyword-tag {
  display: inline-block;
  background: rgba(26, 115, 232, 0.08);
  color: var(--cdo-accent-blue);
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid rgba(26, 115, 232, 0.2);
  transition: all 0.2s;
}

.cdo-keyword-tag:hover {
  background: var(--cdo-accent-blue);
  color: white;
  transform: translateY(-2px);
}

.cdo-keyword-tag.highlight {
  background: var(--cdo-accent-blue);
  color: white;
  border-color: var(--cdo-accent-blue);
}

/* 卡片网格 */
.cdo-card-grid-2 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
  gap: 30px;
}

.cdo-card-grid-3 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 30px;
}

/* 功能卡片 */
.cdo-feature-card {
  background: white;
  border: 1px solid var(--cdo-border-light);
  border-radius: 16px;
  padding: 30px;
  transition: all 0.3s ease;
}

.cdo-feature-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transform: translateY(-4px);
  border-color: var(--cdo-accent-blue);
}

.cdo-card-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 28px;
  margin-bottom: 20px;
}

/* 收益列表 */
.cdo-benefit-item {
  display: flex;
  gap: 24px;
  align-items: flex-start;
  margin-bottom: 30px;
  padding: 24px;
  background: white;
  border-radius: 12px;
  border: 1px solid var(--cdo-border-light);
  transition: all 0.3s ease;
}

.cdo-benefit-item:hover {
  border-color: var(--cdo-accent-blue);
  box-shadow: 0 4px 12px rgba(26, 115, 232, 0.1);
}

.cdo-benefit-number {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  font-weight: 700;
  flex-shrink: 0;
}

/* 课程大纲 */
.cdo-curriculum {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.cdo-day-card {
  background: white;
  border: 2px solid var(--cdo-border-light);
  border-radius: 16px;
  padding: 30px;
  transition: all 0.3s ease;
}

.cdo-day-card:hover {
  border-color: var(--cdo-accent-blue);
  box-shadow: 0 8px 24px rgba(26, 115, 232, 0.1);
}

.cdo-day-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.cdo-day-badge {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
}

.cdo-curriculum-list {
  list-style: none;
  padding: 0;
}

.cdo-curriculum-list li {
  padding: 10px 0;
  color: var(--cdo-text-dark);
  font-size: 16px;
  border-bottom: 1px solid #f1f5f9;
}

.cdo-curriculum-list li:last-child {
  border-bottom: none;
}

.cdo-curriculum-list li i {
  color: var(--cdo-accent-blue);
  margin-right: 10px;
}

/* 讲师卡片 */
.cdo-teacher-card {
  background: white;
  border: 1px solid var(--cdo-border-light);
  border-radius: 16px;
  padding: 30px;
  text-align: center;
  transition: all 0.3s ease;
}

.cdo-teacher-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transform: translateY(-4px);
  border-color: var(--cdo-accent-blue);
}

.cdo-avatar {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 40px;
  margin: 0 auto 20px;
}

.cdo-teacher-title {
  color: var(--cdo-accent-blue);
  font-size: 14px;
  margin-bottom: 16px;
  font-weight: 500;
}

.cdo-teacher-info {
  list-style: none;
  padding: 0;
  text-align: left;
}

.cdo-teacher-info li {
  padding: 6px 0;
  color: var(--cdo-text-gray);
  font-size: 14px;
}

/* 案例卡片 */
.cdo-case-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 24px;
  margin-bottom: 40px;
}

.cdo-case-card {
  background: white;
  border: 1px solid var(--cdo-border-light);
  border-radius: 16px;
  padding: 30px;
  transition: all 0.3s ease;
}

.cdo-case-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transform: translateY(-4px);
}

.cdo-case-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.cdo-industry-tag {
  background: var(--cdo-accent-blue);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.cdo-case-card p {
  margin-bottom: 12px;
  color: var(--cdo-text-gray);
  font-size: 15px;
  line-height: 1.6;
}

/* Logo墙 */
.cdo-logo-wall {
  margin-top: 40px;
  padding: 30px;
  background: var(--cdo-bg-light);
  border-radius: 12px;
}

.cdo-logo-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
}

.cdo-logo-item {
  padding: 12px 24px;
  background: white;
  border-radius: 8px;
  font-weight: 600;
  color: var(--cdo-text-dark);
  font-size: 14px;
  border: 1px solid var(--cdo-border-light);
}

/* 历史活动 */
.cdo-history-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.cdo-history-card {
  background: white;
  border: 1px solid var(--cdo-border-light);
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: all 0.3s ease;
}

.cdo-history-card:hover {
  border-color: var(--cdo-accent-blue);
  box-shadow: 0 8px 24px rgba(26, 115, 232, 0.1);
  transform: translateY(-3px);
}

.cdo-history-label {
  display: inline-block;
  width: fit-content;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #0e5bbf;
  background: rgba(26, 115, 232, 0.12);
  border-radius: 999px;
  padding: 4px 10px;
}

.cdo-history-card p {
  color: var(--cdo-text-gray);
  font-size: 15px;
  line-height: 1.7;
  margin: 0;
}

.cdo-history-link {
  margin-top: auto;
  display: inline-flex;
  align-items: center;
  color: var(--cdo-accent-blue);
  text-decoration: none;
  font-weight: 600;
}

.cdo-history-link:hover {
  color: #0e5bbf;
}

/* 证书卡片 */
.cdo-cert-card {
  display: flex;
  gap: 30px;
  align-items: flex-start;
  background: white;
  border: 2px solid var(--cdo-accent-blue);
  border-radius: 16px;
  padding: 40px;
}

.cdo-cert-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 40px;
  flex-shrink: 0;
}

.cdo-cert-info {
  list-style: none;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.cdo-cert-info li {
  color: var(--cdo-text-gray);
  font-size: 15px;
}

.cdo-cert-info li i {
  color: var(--cdo-accent-blue);
  margin-right: 8px;
}

/* 培训模式卡片 */
.cdo-mode-card {
  background: white;
  border: 2px solid var(--cdo-border-light);
  border-radius: 16px;
  padding: 40px;
  transition: all 0.3s ease;
}

.cdo-mode-card:hover {
  border-color: var(--cdo-accent-blue);
  box-shadow: 0 8px 24px rgba(26, 115, 232, 0.1);
}

.cdo-mode-list {
  list-style: none;
  padding: 0;
  margin-top: 20px;
}

.cdo-mode-list li {
  padding: 12px 0;
  color: var(--cdo-text-gray);
  font-size: 15px;
  border-bottom: 1px solid #f1f5f9;
}

.cdo-mode-list li:last-child {
  border-bottom: none;
}



/* 三列网格布局 */
.cdo-benefit-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}





/* 报名流程 */
.cdo-process {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1000px;
  margin: 0 auto;
  flex-wrap: wrap;
  gap: 20px;
}

.cdo-process-step {
  text-align: center;
  flex: 1;
  min-width: 140px;
}

.cdo-process-number {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  font-weight: 700;
  margin: 0 auto 16px;
}

.cdo-process-arrow {
  color: var(--cdo-accent-blue);
  font-size: 24px;
  flex-shrink: 0;
}

.cdo-process-step p {
  font-size: 14px;
  color: var(--cdo-text-gray);
  margin: 0;
}

/* FAQ */
.cdo-faq {
  max-width: 900px;
  margin: 0 auto;
}

.cdo-faq-item {
  background: white;
  border: 1px solid var(--cdo-border-light);
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 6px;
  transition: all 0.3s ease;
}

.cdo-faq-item:hover {
  border-color: var(--cdo-accent-blue);
  box-shadow: 0 4px 12px rgba(26, 115, 232, 0.1);
}

.cdo-faq-item h4 {
  color: var(--cdo-text-dark);
  margin-bottom: 12px;
}

.cdo-faq-item p {
  color: var(--cdo-text-gray);
  line-height: 1.7;
  margin: 0;
}

/* CTA区 */
.cdo-cta {
  background: linear-gradient(135deg, var(--cdo-primary-dark) 0%, #1a73e8 100%);
  padding: 15px 10px;
  margin-top: 5px;
}

.cdo-cta-content {
  text-align: center;
}

/* 响应式 */
@media (max-width: 768px) {
  .cdo-h1 {
    font-size: 32px;
  }
  
  .cdo-h2 {
    font-size: 26px;
  }
  
  .cdo-card-grid-2,
  .cdo-card-grid-3,
  .cdo-case-grid,
  .cdo-history-grid {
    grid-template-columns: 1fr;
  }
  
  .cdo-info-grid {
    grid-template-columns: 1fr;
  }
  
  .cdo-process {
    flex-direction: column;
  }
  
  .cdo-process-arrow {
    transform: rotate(90deg);
  }
  
  .cdo-cert-card {
    flex-direction: column;
  }
  
  .cdo-cert-info {
    grid-template-columns: 1fr;
  }
}
</style>
